// Sizes come from PocketBase as [{ size, qty }]. They used to be regex-parsed
// out of the `features` prose, which is why this logic was duplicated in three
// components — those copies are gone.

export const getAvailableSizes = (product) =>
  (product?.sizes || []).map((entry) => entry.size);

export const hasMultipleSizes = (product) =>
  getAvailableSizes(product).length > 1;

export const getSingleSize = (product) => {
  const sizes = getAvailableSizes(product);
  return sizes.length === 1 ? sizes[0] : null;
};
